import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ColorSchemeScript, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
// O CSS dos gráficos é pequeno e fica aqui; o JAVASCRIPT deles é que é grande,
// e esse entra por `lazy` dentro da tela inicial — ver `Home.tsx`.
import '@mantine/charts/styles.css';
import { App } from './App.js';
import { CHAVE_TEMA, tema, variaveisDeTema } from './tema.js';
import './estilo.css';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('elemento #raiz não encontrado');

/**
 * `ColorSchemeScript` antes de tudo: ele aplica o tema salvo no atributo do
 * `<html>` antes da primeira pintura. Sem isso, quem escolheu escuro vê um
 * flash branco a cada carregamento.
 *
 * `defaultColorScheme: 'auto'` segue o sistema até a pessoa escolher.
 */
createRoot(raiz).render(
  <StrictMode>
    <ColorSchemeScript defaultColorScheme="auto" localStorageKey={CHAVE_TEMA} />
    <MantineProvider
      theme={tema}
      defaultColorScheme="auto"
      cssVariablesResolver={variaveisDeTema}
    >
      <Notifications position="top-right" limit={3} />
      <App />
    </MantineProvider>
  </StrictMode>,
);
